// extracted by mini-css-extract-plugin
export default {"button":"VYhgQ1uxxXGdVM7ElOPg"};